import { render } from "./preview.vue?vue&type=template&id=5f65904d"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"

import "./preview.vue?vue&type=style&index=0&id=5f65904d&lang=scss"

import exportComponent from "/builds/xbongbong/xbb-pro-module-center/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__